import { FilterPillFn } from 'components/Srp/FilterPills/hooks/useCreateFilterPills';
import { useTranslation } from 'react-i18next';
import { FilterPill, CheckboxValue } from 'types/srpFilters';

// Map checkbox filter keys to translation keys
function getTranslationKey(checkboxFilter: string): string {
  const keyMap: Record<string, string> = {
    'certified pre-owned': 'certifiedPreOwned',
    'natural gas': 'naturalGas',
  };

  return keyMap[checkboxFilter] || checkboxFilter;
}

export default function useCheckboxFilterOptionsPillsCreators(
  stateKey: string,
  suffix?: string
): FilterPillFn {
  const { t } = useTranslation();

  return (filterObj: CheckboxValue): FilterPill[] => {
    function generateLabel(translationKey: string): string {
      const isNumber = !Number.isNaN(Number(translationKey));

      const label = isNumber ? `${translationKey} ` : t(`srp.pills.${translationKey}`);
      return `${label} ${suffix ? t(`${suffix}`) : ''}`;
    }

    return Object.entries(filterObj)
      .filter(([, value]) => value) // Only keep selected filters
      .map(([checkboxFilter]) => {
        const translationKey = getTranslationKey(checkboxFilter);
        return {
          name: checkboxFilter,
          label: generateLabel(translationKey),
          resetState: { [stateKey]: { [checkboxFilter]: false } },
        };
      });
  };
}
